import {
  ChangeDetectionStrategy,
  Component,
  inject,
  forwardRef,
  OnInit,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PlantService } from '@ups/xplat/api/services';
import { dynamicTypeaheadPlantFilter } from '@ups/xplat/dynamic-render';
import { DynamicTypeaheadWebBaseComponent } from '../base/dynamic-typeahead.web-base-component';

const SEARCH_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DynamicTypeaheadplantComponent),
  multi: true,
};

@Component({
  selector: 'ups-dynamic-typeahead-plant',
  templateUrl: 'dynamic-typeahead-plant.component.html',
  providers: [SEARCH_CONTROL_VALUE_ACCESSOR],
  // WI 35909 (S1): template state is marked at each async write in the shared typeahead bases
  // (WI 35584); this subclass adds no template-read async writes of its own.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicTypeaheadplantComponent
  extends DynamicTypeaheadWebBaseComponent
  implements OnInit
{
  private readonly searchplantService = inject(PlantService);

  constructor() {
    super();
    this.queryFilter = dynamicTypeaheadPlantFilter;
  }

  ngOnInit() {
    super.ngOnInit();
    this.searchQuery = this.searchplantService.search.bind(
      this.searchplantService
    );
    // this.config?.options?.pointToSparta
    //   ? this.searchplantService.search.bind(this.searchplantService)
    //   : this.searchplantVPService.search.bind(this.searchplantVPService);
  }
}
